<form [formGroup]="selectedUnitForm" class="flex-row">
    <h-radio-button
        [id]="uuidForm + '-international-unit'"
        [name]="'unitType'"
        [controlName]="'unitTypeControl'"
        [label]="labelInt"
        class="radio-button"
        i18n-label
        [value]="'international'"
        [labelStyle]="'normal'"
        [hasSeparator]="false"
        [isCollapsible]="false"
        [buttonStyle]="'thin'"
        [isAnimationDisabled]="true">
    </h-radio-button>
    <h-radio-button
        [id]="uuidForm + '-imperial-unit'"
        [name]="'unitType'"
        [controlName]="'unitTypeControl'"
        [label]="labelImp"
        class="radio-button radio-button-right"
        i18n-label
        [value]="'imperial'"
        [labelStyle]="'normal'"
        [hasSeparator]="false"
        [isCollapsible]="false"
        [buttonStyle]="'thin'"
        [isAnimationDisabled]="true">
    </h-radio-button>
</form>
@if (currentContent?.headers?.length && currentContent?.lines?.length) {
<div class="block-table paragraph-small">
    <table role="table">
        <caption id="table-caption" i18n="@@hermes.size_guide.size_comparaison_table" class="sr-only"
            >Find your size</caption
        >
        @if(currentContent?.headers?.length) {
        <thead>
            <tr role="row">
                @for (headerContent of currentContent?.headers; track headerContent) {
                <th role="columnheader" scope="col">{{ headerContent }}</th>
                }
            </tr>
        </thead>
        } @if(currentContent?.lines?.length){
        <tbody>
            @for (rowContent of currentContent?.lines; track rowContent) {
            <tr role="row">
                @for (data of rowContent; track data) {
                <td>{{ data }}</td>
                }
            </tr>
            }
        </tbody>
        }
    </table>
</div>
}
